// Needed due to following issue - https://github.com/vitejs/vite/issues/2778#issuecomment-810086159
window.global ||= window;